import React from "react";
import { Link } from "react-router-dom";

import { Button, Input, Row } from "antd";
import ButtonGroup from "antd/es/button/button-group";

import MallLoginComponent from "../common/MallLoginComponent";

const LandingLoginComponent = () => {
	const processList = [
		{
			title: "수수료가 높은 상품을\n선택해보세요",
			description:
				"수수료와 가격, 상품 내용을 꼼꼼히 살펴보고\n마음에 드는 상품을 선택해보세요",
		},
		{
			title: "링크를 복사해서\n공유해 보세요",
			description:
				"상품링크를 복사해서 링크로 유입될 수 있도록\n적절한 곳에 공유해보세요",
		},
		{
			title: "구매한 상품의 수익을\n함께 나눠드려요",
			description:
				"누군가 공유한 링크를 통해 상품을 구매하면\n상품의 지정 수수료 만큼 수익으로 돌려드려요",
		},
	];
	return (
		<div className="noselect landing-home">
			<div className={`together-landing-header-bgImg-wrap`}>
				<picture>
					<source
						srcSet={`/assets/images/landing/together1-m.png 590w`}
						media="(max-width: 768px)"
					/>
					{/*<source srcSet={`/assets/images/landing/together1.jpg 1920w`} media="(max-width: 768px)"/>*/}
					<img
						// srcSet="/assets/images/landing/together1-m.png 590w,
						//       /assets/images/landing/together1.jpg 1920w"
						sizes="(min-width: 768px) 590px"
						src={`/assets/images/landing/together1.jpg`}
						alt={`당영 투게더 1`}
						style={{
							width: "100%",
							minHeight: "50vh",
							maxHeight: `calc(100vh - 5.5em)`,
						}}
					/>
				</picture>
				<div
					className={`together-text-div`}
					style={{ width: "50%", top: "50%" }}
				>
					<img
						src={`/assets/images/landing/together1-1.png`}
						alt={`당영 투게더 1-1`}
						style={{
							objectFit: "contain",
							width: 250,
						}}
					/>

					{/* 당영몰 로그인 */}
					<MallLoginComponent />

					<div
						style={{
							width: "23%",
							paddingTop: "5rem",
							position: "relative",
							display: "none",
						}}
					>
						<img
							src={`/assets/images/landing/together1-3.png`}
							alt={`당영 투게더 1-2`}
							// style={{
							//     width: "25%",
							//     height: "auto",
							//     paddingTop: "5em"
							// }}
							className={`ball-arrow-img`}
						/>
					</div>
				</div>
			</div>
			{/* 당영투게더 */}
			<div className={`main-wrap together-wrap`} id={`landing-width`}>
				<div className={`together-div`}>
					<div className={`together-column`}>
						<div>
							<p className={`blue-title`}>당영투게더</p>
							<p className={`big-title`}>
								당영투게더와 함께{"\n"}수익을 만들어보세요
							</p>
						</div>
						<p
							className={`small-title`}
							//    style={{
							//     fontSize: "1.3em"
							// }}
						>
							당신의 영양제 회원이라면 누구나 쉽게{"\n"}
							상품을 공유하며 수익을 만들어가요
						</p>
					</div>

					<div className={`together-column`}>
						<img
							className={`together-img-2`}
							src={`/assets/images/landing/together2.png`}
							alt={`당영 투게더 2`}
							style={{
								height: "100%",
								width: "auto",
								maxHeight: "20em",
								objectFit: "contain",
							}}
						/>
					</div>
				</div>
			</div>

			{/* 수익 프로세스 */}
			<div
				className={`main-wrap together-wrap`}
				id={`landing-width`}
				style={{ backgroundColor: "#f1f3f5" }}
			>
				<div className={`together-div`}>
					<div
						className={`together-column together-profit`}
						style={{ width: "100%" }}
					>
						<div>
							<p className={`blue-title`}>수익 프로세스</p>
							<p className={`big-title`}>
								쉽고 간편하게{"\n"}
								언제 어디서든{"\n"}
								수익을 만들 수 있어요
							</p>
						</div>
						{processList.map((item, idx) => (
							<div
								className={`together-group`}
								key={`수익 프로세스 ${idx}`}
								style={
									idx === 1
										? {
												flexDirection: "row-reverse",
										  }
										: {}
								}
							>
								<div className={`together-each`}>
									<p className={`blue-title`}>0{idx + 1}</p>
									<p className={`small-title`}>{item.title}</p>
									{/*<p className={`normal-text-font`}>{item.description}</p>*/}
								</div>
								<div className={`together-each`}>
									<img
										src={`/assets/images/landing/together3-${idx + 1}.png`}
										alt={`당영 투게더 3-${idx + 1}`}
										style={{
											height: "100%",
											width: "auto",
											maxHeight: "15em",
											objectFit: "contain",
											boxShadow: "-12px 6px 15px 0 rgba(109, 117, 128, 0.25)",
											borderRadius: "30px",
										}}
									/>
								</div>
							</div>
						))}
					</div>
				</div>
			</div>

			{/* 신청방법 */}
			<div className={`main-wrap together-wrap`} id={`landing-width`}>
				<div className={`together-div`}>
					<div className={`together-column`} style={{ width: "100%" }}>
						<div>
							<p className={`blue-title`}>신청방법</p>
							<p className={`big-title`}>신청도 누구나{"\n"}쉽고 간편하게</p>
							{/*<img*/}
							{/*    src={`/assets/images/landing/together4.png`}*/}
							{/*    alt={`당영 투게더 4`}*/}
							{/*    style={{*/}
							{/*        height: "auto",*/}
							{/*        width: "100%",*/}
							{/*        // maxHeight: "20em",*/}
							{/*        objectFit: "contain"*/}
							{/*    }}*/}
							{/*/>*/}
							<div className={`together-apply-group`}>
								<img
									src={`/assets/images/landing/together4-1.png`}
									alt={`당영 투게더 4-1`}
									style={{
										height: "auto",
										width: "32%",
										objectFit: "contain",
										borderRadius: "30px",
										boxShadow: "0 0 10px 0 rgba(109, 117, 128, 0.15)",
									}}
								/>

								<img
									src={`/assets/images/landing/together4-2.png`}
									alt={`당영 투게더 4-2`}
									style={{
										height: "auto",
										width: "32%",
										objectFit: "contain",
										borderRadius: "30px",
										boxShadow: "0 0 10px 0 rgba(109, 117, 128, 0.15)",
									}}
								/>
								<img
									src={`/assets/images/landing/together4-3.png`}
									alt={`당영 투게더 4-3`}
									style={{
										height: "auto",
										width: "32%",
										objectFit: "contain",
										borderRadius: "30px",
										boxShadow: "0 0 10px 0 rgba(109, 117, 128, 0.15)",
									}}
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* 수익관리 */}
			<div
				className={`main-wrap together-wrap`}
				id={`landing-width`}
				style={{ backgroundColor: "#f1f3f5" }}
			>
				<div className={`together-div`}>
					<div className={`together-column`} style={{ width: "100%" }}>
						<div>
							<p className={`blue-title`}>수익관리</p>
							<p className={`big-title`}>
								내 링크로 구매된 실적을{"\n"}한 눈에 확인하세요
							</p>
							<p className={`small-title`}>
								매달 말일 구매 수익을 정산해 다음달 15일에{"\n"}
								등록된 계좌로 자동으로 수수료가 지급됩니다
							</p>
							<img
								className={`together-img-2`}
								src={`/assets/images/landing/together5.png`}
								alt={`당영 투게더 5`}
								style={{
									height: "auto",
									width: "100%",
									// maxHeight: "20em",
									objectFit: "contain",
									paddingTop: "5rem",
								}}
							/>
						</div>
					</div>
				</div>
			</div>
			{/*<img src={`${process.env.REACT_APP_HOST}/assets/images/landing/landing1.jpg`} style={{width: "100%"}}/>*/}
			{/*<img src={`${process.env.REACT_APP_HOST}/assets/images/landing/landing2.jpg`} style={{width: "100%"}}/>*/}
			{/*<img src={`${process.env.REACT_APP_HOST}/assets/images/landing/landing3.jpg`} style={{width: "100%"}}/>*/}
			{/*<img src={`${process.env.REACT_APP_HOST}/assets/images/landing/landing4.jpg`} style={{width: "100%"}}/>*/}
		</div>
	);
};

export default LandingLoginComponent;
